var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g3939",
    clipPath: "url(#clip0_311_298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3939_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_311_298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3945",
    d: "M0 0H28V28H0V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_311_298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3949"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3951",
    d: "M19.6279 16.653C19.7585 17.0664 20.0175 17.4275 20.3672 17.6838C20.717 17.94 21.1393 18.0781 21.5729 18.078C22.0064 18.078 22.4286 17.9399 22.7782 17.6836C23.1278 17.4274 23.3866 17.0663 23.5169 16.653",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3955",
    d: "M18.6896 11.9779V11.9209C18.6876 11.2517 18.5441 10.5905 18.2683 9.98069C17.9925 9.3709 17.5908 8.82637 17.0896 8.38294C16.6171 7.96243 16.2368 7.44864 15.9726 6.87394C15.6995 6.27779 15.5586 5.62965 15.5596 4.97394C15.5596 3.76376 16.0403 2.60314 16.896 1.74741C17.7518 0.891681 18.9124 0.410953 20.1226 0.410953H23.0316C23.631 0.410196 24.2247 0.527909 24.7785 0.757358C25.3323 0.986807 25.8353 1.32347 26.2586 1.74796C26.6831 2.17122 27.0197 2.6742 27.2492 3.228C27.4786 3.7818 27.5963 4.3755 27.5956 4.97495C27.5972 5.98586 27.2615 6.96841 26.6416 7.76694",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3959",
    d: "M24.4551 11.977V11.943C24.4586 10.8578 24.8322 9.80621 25.5141 8.96198",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3963",
    d: "M19.1143 14.315H24.0303C24.3403 14.315 24.6377 14.1918 24.8569 13.9726C25.0762 13.7534 25.1993 13.456 25.1993 13.146C25.1993 12.836 25.0762 12.5386 24.8569 12.3194C24.6377 12.1002 24.3403 11.977 24.0303 11.977H19.1143C18.8043 11.977 18.5069 12.1002 18.2877 12.3194C18.0685 12.5386 17.9453 12.836 17.9453 13.146C17.9453 13.456 18.0685 13.7534 18.2877 13.9726C18.5069 14.1918 18.8043 14.315 19.1143 14.315Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3967",
    d: "M19.1143 16.653H24.0303C24.3403 16.653 24.6377 16.5298 24.8569 16.3106C25.0762 16.0914 25.1993 15.794 25.1993 15.484C25.1993 15.174 25.0762 14.8766 24.8569 14.6574C24.6377 14.4382 24.3403 14.315 24.0303 14.315H19.1143C18.8043 14.315 18.5069 14.4382 18.2877 14.6574C18.0685 14.8766 17.9453 15.174 17.9453 15.484C17.9453 15.794 18.0685 16.0914 18.2877 16.3106C18.5069 16.5298 18.8043 16.653 19.1143 16.653Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3971",
    d: "M21.5723 11.977V8.47699",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3973"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3975",
    d: "M18.9316 5.83295C18.9316 6.53338 19.2099 7.20513 19.7052 7.70042C20.2005 8.1957 20.8722 8.47395 21.5726 8.47395C22.2731 8.47395 22.9448 8.1957 23.4401 7.70042C23.9354 7.20513 24.2136 6.53338 24.2136 5.83295",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3977"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3979",
    d: "M6.87613 19.738H23.8291C24.0975 19.7381 24.3629 19.794 24.6086 19.9021C24.8542 20.0102 25.0747 20.1681 25.2561 20.366L27.0811 22.356C27.4084 22.7132 27.5899 23.18 27.5899 23.6645C27.5899 24.1489 27.4084 24.6158 27.0811 24.973L25.2561 26.963C25.0747 27.1607 24.8542 27.3185 24.6085 27.4264C24.3629 27.5344 24.0975 27.5901 23.8291 27.59H2.01112C1.58678 27.59 1.17982 27.4214 0.879761 27.1213C0.579703 26.8213 0.411133 26.4143 0.411133 25.99V21.338C0.411133 20.9136 0.579703 20.5067 0.879761 20.2066C1.17982 19.9065 1.58678 19.738 2.01112 19.738H5.24413",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3983",
    d: "M7.13416 0.409975H2.01016C1.58582 0.409975 1.17884 0.578546 0.878784 0.878604C0.578726 1.17866 0.410156 1.58563 0.410156 2.00997V6.65997C0.410156 7.08432 0.578726 7.49129 0.878784 7.79135C1.17884 8.0914 1.58582 8.25997 2.01016 8.25997H7.13416C7.40255 8.25993 7.66801 8.20408 7.91367 8.09597C8.15933 7.98786 8.37982 7.82985 8.56116 7.63197L10.3862 5.64197C10.7136 5.28488 10.8953 4.81798 10.8953 4.33347C10.8953 3.84896 10.7136 3.38207 10.3862 3.02497L8.56116 1.03497C8.37956 0.837645 8.15895 0.680195 7.9133 0.572606C7.66765 0.465018 7.40233 0.409637 7.13416 0.409975Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3987",
    d: "M12.6072 10.074H2.00723C1.58289 10.074 1.17591 10.2425 0.875854 10.5426C0.575796 10.8427 0.407227 11.2496 0.407227 11.674V16.324C0.407227 16.7483 0.575796 17.1553 0.875854 17.4553C1.17591 17.7554 1.58289 17.924 2.00723 17.924H12.6072C12.8756 17.9241 13.141 17.8684 13.3866 17.7604C13.6323 17.6525 13.8528 17.4947 14.0342 17.297L15.8593 15.307C16.1867 14.9499 16.3684 14.483 16.3684 13.9985C16.3684 13.514 16.1867 13.0471 15.8593 12.69L14.0342 10.7C13.8527 10.5025 13.6322 10.3448 13.3865 10.2371C13.1409 10.1293 12.8755 10.0738 12.6072 10.074Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3989"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3991",
    d: "M3.27246 6.10098L4.59846 2.61998C4.60449 2.60531 4.61474 2.59276 4.62792 2.58392C4.64109 2.57509 4.6566 2.57037 4.67246 2.57037C4.68832 2.57037 4.70383 2.57509 4.717 2.58392C4.73018 2.59276 4.74043 2.60531 4.74646 2.61998L6.06046 6.10198",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3995",
    d: "M3.68555 5.23499H5.65355",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3999",
    d: "M5.11046 13.045C5.11046 13.1516 5.08946 13.2572 5.04865 13.3557C5.00785 13.4542 4.94804 13.5437 4.87263 13.6191C4.79723 13.6945 4.70772 13.7543 4.6092 13.7952C4.51068 13.836 4.4051 13.857 4.29846 13.857H3.27246V12.228H4.29846C4.40548 12.2281 4.51142 12.2494 4.6102 12.2905C4.70899 12.3317 4.79867 12.392 4.87411 12.4679C4.94955 12.5438 5.00927 12.6338 5.04982 12.7328C5.09038 12.8319 5.11099 12.9379 5.11046 13.045Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4003",
    d: "M5.42734 14.81C5.42734 15.0619 5.32725 15.3036 5.14909 15.4817C4.97093 15.6599 4.7293 15.76 4.47734 15.76H3.27734V13.855H4.47734C4.60252 13.855 4.72646 13.8797 4.84205 13.9278C4.95764 13.9758 5.06259 14.0462 5.15087 14.135C5.23915 14.2237 5.30902 14.3291 5.35647 14.4449C5.40392 14.5607 5.428 14.6848 5.42734 14.81Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4007",
    d: "M6.02546 22.2C5.73386 22.0035 5.39006 21.899 5.03846 21.9C4.57009 21.9 4.1209 22.086 3.78971 22.4172C3.45852 22.7484 3.27246 23.1976 3.27246 23.666C3.27246 24.1343 3.45852 24.5835 3.78971 24.9147C4.1209 25.2459 4.57009 25.432 5.03846 25.432C5.39403 25.4405 5.73987 25.3153 6.00746 25.081C6.05866 25.0352 6.10645 24.9857 6.15046 24.933",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.2ed53ca872bb482e63ad15350299f213.svg";
export { ForwardRef as ReactComponent };